import { queryOptions } from '@tanstack/react-query';
import type { ListPaymentsQuery } from '@klopotun/contracts';
import { paymentQueryRoot } from '../../../../shared/api/index.js';
import { getPayment } from '../requests/get-payment.js';
import { getPayments } from '../requests/get-payments.js';

/**
 * An empty filter is not "every payment": design note C10 makes the server answer a statusless
 * request with the active and the paused ones.
 */
const EVERY_LIVE_PAYMENT: ListPaymentsQuery = {};

export const paymentQueries = {
  ...paymentQueryRoot,
  list: (query: ListPaymentsQuery = EVERY_LIVE_PAYMENT) =>
    queryOptions({
      queryKey: [...paymentQueryRoot.lists(), query] as const,
      queryFn: ({ signal }) => getPayments(query, signal),
    }),
  detail: (id: string) =>
    queryOptions({
      queryKey: [...paymentQueryRoot.details(), id] as const,
      queryFn: ({ signal }) => getPayment(id, signal),
    }),
};
